import {useMe} from '@features/user/queries/useMe'
import {isReviewerOnly} from '@features/user/utils'
import {useChatbotStore} from '@features/chatbot/store/chatbotStore'
import {useURLParsedParams} from '@hooks/useURLParsedParams'
import {AssignmentUrlParams} from '@features/assignment/types'
import {TASK_CATEGORY_REVIEW} from '@features/assignment/utils'

/**
 * Review-only freelancers never see the chatbot. Freelancers with other roles too
 * only lose it while viewing a review assignment.
 */
export const useIsChatbotHidden = () => {
    const meQuery = useMe()
    const urlParams = useURLParsedParams(AssignmentUrlParams)
    const currentAssignment = useChatbotStore(state => state.assignment)

    if (!meQuery.data) {
        return false
    }

    if (isReviewerOnly(meQuery.data)) {
        return true
    }

    const isViewingReviewAssignment =
        urlParams.success &&
        currentAssignment?.code === urlParams.data.code &&
        currentAssignment.task_category.name == TASK_CATEGORY_REVIEW

    return isViewingReviewAssignment
}
